import script from "./ProspeccaoMatriculas.vue?vue&type=script&setup=true&lang=js"
export * from "./ProspeccaoMatriculas.vue?vue&type=script&setup=true&lang=js"

import "./ProspeccaoMatriculas.vue?vue&type=style&index=0&id=7b75f014&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b75f014"]])

export default __exports__